module.exports = "/legacy/c824d0ef40f8c5df72e2c3efa9d5d0aa.svg";